import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ItemInformationsForm from 'components/entities/items/ItemInformationsForm';
import BasePage from 'components/UI/BasePage';
import { useGetEntitiesQuery } from 'services/entities/api';
import links, { linkKey, matchesLinkKey } from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const ItemUpsertPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { entitySlug, itemId } = useParams<{ entitySlug: string, itemId: string }>();
  const { data: entities } = useGetEntitiesQuery();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  const entity = entities && entities.find(item => matchesLinkKey(item, entitySlug));

  return (entity && itemId) ? (
    <>
      <Helmet>
        <title>{t('createAnItem')}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.paths.entities, navigate), label: t('entities') },
            { ...spaLinkProps(links.entity(linkKey(entity)), navigate), label: entity.name },
            { label: t('createAnItem') },
          ]}
        />
        <h4>{t('createAnItem')}</h4>
        <ItemInformationsForm
          entityId={entity.id}
          id={itemId}
        />
      </BasePage>
    </>
  ) : null;
};

export default ItemUpsertPage;
